import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { useFormikContext } from 'formik';
import { HistoricalFormVM } from 'front-office/view-models/historical/historical-form';
import PaymentCertificate from 'front-office/components/shared/payment';
import HistoricalAnpr from './historical';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalCertificateProps {
  open: boolean;
  onClose: (open: boolean) => void;
}

const ModalCertificate = ({ open, onClose }: ModalCertificateProps): React.ReactElement => {
  const formContext = useFormikContext<HistoricalFormVM>();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Richiesta Certificato
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <HistoricalAnpr />
        <div className="pmi-mt-4">
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DatePicker
                label="Data di riferimento"
                aria-label="Data di riferimento"
                value={formContext.values.dateForm || null}
                onChange={(date) => {
                  formContext.setFieldValue('dateForm', date);
                }}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="reference-date"
                    fullWidth
                    onBlur={(event) => {
                      formContext.handleBlur(event);
                    }}
                    helperText={formContext.errors.dateForm}
                    error={formContext.touched.dateForm && Boolean(formContext.errors.dateForm)}
                  />
                )}
              />
            </Grid>
          </Grid>
        </div>
        <PaymentCertificate showHistoricalFields />
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          type="button"
          onClick={() => formContext.handleSubmit()}
        >
          Richiesta Certificato
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalCertificate.displayName = 'Modal request certificate';

export default ModalCertificate;
